import { render, staticRenderFns } from "./secretMessageIcon.vue?vue&type=template&id=200ad119&scoped=true"
import script from "./secretMessageIcon.vue?vue&type=script&lang=js"
export * from "./secretMessageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200ad119",
  null
  
)

export default component.exports